{
  "CUSTOM_ROLE": {
    "HEADER": "Custom Roles",
    "LEARN_MORE": "Learn more about custom roles",
    "DESCRIPTION": "Custom roles are roles that are created by the account owner or admin. These roles can be assigned to agents to define their access and permissions within the account. Custom roles can be created with specific permissions and access levels to suit the requirements of the organization.",
    "HEADER_BTN_TXT": "Add custom role",
    "LOADING": "Fetching custom roles...",
    "SEARCH_404": "Er zijn geen items die overeenkomen met deze zoekopdracht.",
    "PAYWALL": {
      "TITLE": "Upgrade to create custom roles",
      "AVAILABLE_ON": "The custom role feature is only available in the Business and Enterprise plans.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to advanced features like team management, automations, custom attributes, and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "The custom role feature is only available in the paid plans.",
      "UPGRADE_PROMPT": "Upgrade to a paid plan to access advanced features like audit logs, agent capacity, and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "LIST": {
      "404": "There are no custom roles available in this account.",
      "TITLE": "Manage custom roles",
      "DESC": "Custom roles are roles that are created by the account owner or admin. These roles can be assigned to agents to define their access and permissions within the account. Custom roles can be created with specific permissions and access levels to suit the requirements of the organization.",
      "TABLE_HEADER": {
        "NAME": "Naam",
        "DESCRIPTION": "Beschrijving",
        "PERMISSIONS": "Permissions",
        "USAGE_COUNT": "In gebruik door",
        "ACTIONS": "Acties"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Manage all conversations",
      "CONVERSATION_UNASSIGNED_MANAGE": "Manage unassigned conversations and those assigned to them",
      "CONVERSATION_PARTICIPATING_MANAGE": "Manage participating conversations and those assigned to them",
      "CONTACT_MANAGE": "Manage contacts",
      "ACCESS_ALL_REPORTS": "Alle rapporten bekijken",
      "KNOWLEDGE_BASE_MANAGE": "Manage knowledge base",
      "DATA_ASSISTANT_MANAGE": "Data-assistent beheren",
      "CALL_RECORDING_ACCESS": "Toegang tot alle gespreksopnames"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Naam",
        "PLACEHOLDER": "Please enter a name.",
        "ERROR": "Naam is vereist."
      },
      "DESCRIPTION": {
        "LABEL": "Beschrijving",
        "PLACEHOLDER": "Please enter a description.",
        "ERROR": "Omschrijving is vereist."
      },
      "PERMISSIONS": {
        "LABEL": "Permissions",
        "ERROR": "Permissions are required."
      },
      "CANCEL_BUTTON_TEXT": "Annuleren",
      "API": {
        "ERROR_MESSAGE": "Kan geen verbinding maken met de Woot server. Probeer het opnieuw."
      }
    },
    "ADD": {
      "TITLE": "Add custom role",
      "DESC": " Custom roles allows you to create roles with specific permissions and access levels to suit the requirements of the organization.",
      "SUBMIT": "Bevestigen",
      "API": {
        "SUCCESS_MESSAGE": "Custom role added successfully."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Bewerken",
      "TITLE": "Edit custom role",
      "DESC": " Custom roles allows you to create roles with specific permissions and access levels to suit the requirements of the organization.",
      "SUBMIT": "Vernieuwen",
      "API": {
        "SUCCESS_MESSAGE": "Custom role updated successfully."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Verwijderen",
      "API": {
        "SUCCESS_MESSAGE": "Custom role deleted successfully.",
        "ERROR_MESSAGE": "Kan geen verbinding maken met de Woot server. Probeer het opnieuw."
      },
      "CONFIRM": {
        "TITLE": "Verwijdering bevestigen",
        "MESSAGE": "Weet u zeker dat u wilt verwijderen ",
        "YES": "Ja, verwijder ",
        "NO": "Nee, bewaar"
      }
    }
  }
}
